import { render, staticRenderFns } from "./warning-record.vue?vue&type=template&id=33f0c3ba&"
import script from "./warning-record.vue?vue&type=script&lang=js&"
export * from "./warning-record.vue?vue&type=script&lang=js&"
import style0 from "./warning-record.vue?vue&type=style&index=0&id=33f0c3ba&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports